/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const getMetaNode = (name: any) => document.querySelector(`meta[name="${name}"]`); // oxlint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const getHead = () => document.head || document.querySelector('head');
/**
 * add the meta tag element if it does not exist, or replace the old one if it exist
 */
export const addThemeColor = (content: string): void => {
	if (!content || typeof document === 'undefined' || __SERVER__) {
		return;
	}
	const existingMeta = getMetaNode('theme-color');

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const meta = document.createElement('meta');
	meta.name = 'theme-color';
	meta.content = content;
	if (existingMeta) {
		existingMeta.replaceWith?.(meta);
	} else {
		const head = getHead();
		if (head) {
			head.appendChild?.(meta);
		}
	}
};
